var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupeOutlinedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "moreDetails",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 20,
    height: 20,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2045",
    "data-name": "Groupe 2045",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2044",
    "data-name": "Groupe 2044",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_746",
    "data-name": "Trac\\xE9 746",
    d: "M11,5H9V9H5v2H9v4h2V11h4V9H11ZM10,0a10,10,0,0,0,0,20h8a2.006,2.006,0,0,0,2-2V10A10.016,10.016,0,0,0,10,0m0,18a8,8,0,1,1,8-8,8.011,8.011,0,0,1-8,8",
    fill: "#1454FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupeOutlinedBlue);
export default __webpack_public_path__ + "static/media/LoupeOutlinedBlue.8fae44c33d781313ef833f3003a3e66d.svg";
export { ForwardRef as ReactComponent };